/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Current status of the user
 */
export type Status = (typeof Status)[keyof typeof Status];

export const Status = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  BLOCKED: 'blocked',
  DEACTIVATED: 'deactivated',
  INACTIVE: 'inactive',
  INVITED: 'invited',
  PAUSED: 'paused',
} as const;
